import styled from 'styled-components';

export const AdminDashboardWrapper: any = styled.div` 

.pageTitleSection{
    position: relative;
    left: -30px;
}

.SurveySelect{
    width: 300px;
}

.contentSection .contentMapSection{
    border-bottom: 2px solid #aaa;
    padding-bottom: 50px;
}

.contentMapSection .contentRightSection{
    height: 400px;
    overflow-y: scroll;
}

.countryInfoFooter{
    padding: 15px 15px;
}

.contentRightSection .countryInfo tr th >span, .contentRightSection .countryInfo tr td >span{
    color: #000;
    font-size: 18px;
}

.contentMapBottomSection{
    padding: 20px 0px;
}

.panel-blue{
    border: 2px solid #0099FF;
    padding: 15px 15px;
    color: #0099FF;
    cursor: pointer;
    min-height: 135px;
    position: relative;
}
.panel-blue .panel-body{
    font-size: 40px !important;
    font-weight: 700;
    text-align: right;
}
.panel-blue .panel-heading{
    font-size: 24px;
    bottom: 10%;
    position: absolute;
}

.panel-blue-filled{
    background-color: #69C5E4;
    color: #fff;
    padding: 12px 15px;
}
.panel-blue-filled .panel-heading{
    font-size: 24px;
}
.panel-blue-filled .formControl{
    margin: 0px;
}
.panel-blue-filled .formControl .selectControl:before{
    border-bottom: 0px !important;
}
.panel-blue-filled .selectControl{
    background-color: #fff;
    border-radius: 50px;
    border-bottom: 0px;
}
.panel-blue-filled .selectControl [class*="MuiSelect-select-"]{
    padding-left: 6px;
}
.panel-blue-filled .selectControl > div{
    padding-left: 10px;
}
.btn-white{
    background-color: #fff;
    color: #0099FF;
    font-weight: 700;
    text-transform: initial;
}
.btn-white span{
    font-size: 14px;
}
.btn-white:hover, .btn-white:active{
    background-color: #fff;
    color: #0099FF;
}

.contentRightSection .countryInfo tbody tr td{
    border-bottom: 0px;
}

.adminScreen .media-list-wrapper .media-list:first-child{
    border-bottom: 0px;
}
.adminScreen .media-list-wrapper .media-list .ExpansionPanel{
    box-shadow: none;
}
.adminScreen .MuiExpansionPanelSummary-expandIcon-307{
    color: #0099ff;
}
.media-list-wrapper .media-list .media-body {
    width: 90%;
}
.media-insidecontent-acc-group .ExpansionPanelDetails .media-content .media-body {
    width: 80%;
}
.media-insidecontent-acc-group .ExpansionPanelDetails .media-content .media-icon{
    margin-top: 10px;
    margin-right: 10px;
}
.media-insidecontent-acc-group .ExpansionPanelSummary .MuiExpansionPanelSummary-content-306{
    margin: 0px 0px;
}

.ExpansionPanelMain .media-content .media-body h5{
    margin: 5px 0px !important;
}

.media-insidecontent-acc-group .ExpansionPanelDetails .media-content .media-body h5{
    margin: 15px 0px !important;
}

@media screen and (max-width: 1440px) and (min-width: 1281px) {

// .mediaWidth100{
//     flex-grow: 0;
//     max-width: 100%;
//     flex-basis: 100%;
// }

  } 

 .legendDiv{
    margin-top: -101px!important;
}
.listsquare{
    list-style-type:square;font-size: 24px;
    display: flex;
    justify-content: space-between;
}
.listsquare li{
    font-size: 36px;
}
.listsquare li span{
    color:black;
    vertical-align:middle;
}
.color-red{color:red}
.color-green{color: green;}
.color-orange{color: orange;}
`


// WEBPACK FOOTER //
// ./src/styles/admindashboard.tsx